export default __webpack_public_path__ + "static/media/CEC.bf7ced6f.png";